import axios from 'axios';

// slices
import { setMainLoading, setSubModules } from '../../../app/adminSlice';

// link API
const subModulesLink = window.appConfig.restapiUrl + "/account/all_submodules/";


export const getGisSubModule = async (dispatch) =>{
    try {

        dispatch(setMainLoading(true));
        const response = await axios.get(subModulesLink);

        if(response){
            dispatch(setSubModules(response?.data?? {}));
        }

        dispatch(setMainLoading(false));
    } catch (error) {
        console.error("Failed to fetch  Submodules Info: ", error.message)
        dispatch(setMainLoading(false));
    }
}
